<template>
  <div class="editPage" v-loading="subLoading">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
      <Settlement ref="settlement" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import Settlement from './settlement';
import SubBtnBox from 'components/subBtnBox';
import {
  customerArchivesEdit,
  customerArchivesDetail,
  customerArchivesList,
} from 'api/archives';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    Settlement,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/archives/customer/archives/edit',
      formComponents: ['baseForm', 'settlement'],
      editParams: {
        type: 1,
      },
      subLoading: false,
      compareFlag: true,
      companyName: '',

      // 需要对比的参数
      compareParams: {
        companyName: '',
        lineName: '',
        linePhone: '',
        orgId: 0,
        address: '',
        state: '',
        reciveTime: '',
        reciveMonth: '',
        reciveDay: '',
        collectionTime: '',
        collectionMonth: '',
        collectionDay: '',
        payWay: '',
        customerType: 0,
      },

    };
  },
  computed: {
    detailParams () {
      return {
        customerId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: customerArchivesDetail,
    editApi: customerArchivesEdit,
    async getCustomerId () {
      let customerId = 0;
      if (this.companyName && this.companyName.length) {
        const res = await customerArchivesList({
          page: 1,
          state: -1,
          customerCode: '',
          companyName: this.companyName,
        });
        if (!res.failed) {
          if (res && res.items && res.items.length) {
            if (res.items[0] && res.items[0].customerId) {
              customerId = res.items[0].customerId;
            }
          }
        }
      }
      this.companyName = '';
      return customerId;
    },
    handleParams (params) {
      if (!this.$route.query.id) {
        // 新增的时候记录下
        this.companyName = params.companyName;
      }
    },
    async handleSubSucc (res) {
      if (this.$route.query.id) {
        if (res && res.code === 202) {
          this.$alert(res.msg, '温馨提示', {
            confirmButtonText: '我知道了',
          });
        } else {
          this.$message({
            type: 'success',
            message: '保存成功',
          });
        }
        this.close();
      } else {
        const customerId = await this.getCustomerId();
        // 由于有两个地方调过来又要调回去，所以要临时存到本地缓存去做处理，跳转回去之后马上清除本地缓存
        if (this.$route.query.fromPage && customerId) {
          // 要在 this.close() 之前存在本地，然后执行完 this.close() 之后再读取，因为用普通变量会在 close 之后丢失
          sessionStorage.setItem('customerId', customerId);
          sessionStorage.setItem('fromPage', this.$route.query.fromPage);
          sessionStorage.setItem('fromPageLabel', decodeURIComponent(this.$route.query.fromPageLabel));
          this.close();
          const fromPage = sessionStorage.getItem('fromPage');
          const label = sessionStorage.getItem('fromPageLabel');
          sessionStorage.removeItem('fromPage');
          const url = `/manage/distribution/${fromPage}/edit?id=`;
          this.jump({
            label,
            url,
          });
          return;
        }
        this.close();
        // 新增状态需要提示引导
        if (res && res.code === 202) {
          this.$alert(res.msg, '温馨提示', {
            confirmButtonText: '我知道了',
          });
        } else {
          const confirmRes = await this.$confirm('保存成功，是否要增加该客户的线路资料？', '温馨提示', {
            confirmButtonText: '去增加线路',
            cancelButtonText: '取消',
            type: 'success',
          }).catch(() => {
            this.companyName = '';
          });
          if (confirmRes === 'confirm') {
            this.jump({
              label: '新增线路',
              url: `/manage/archives/customer/line/edit?customerId=${customerId}`,
              full: true,
            });
          }
        }
      }
    },
  },
  async mounted () {
    await this.$refs.baseForm.getList();
    await this.$refs.settlement.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
